var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 22.999,
    viewBox: "0 0 23 22.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2124",
    "data-name": "Rectangle 2124",
    width: 23,
    height: 22.999,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M64.171,185.376h9.55c.442,0,.437.73,0,.73h-9.55a.367.367,0,0,1,0-.731",
    transform: "translate(-61.49 -178.551)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M263.5,261.443a.525.525,0,0,1,.137,1.041,7.11,7.11,0,0,1-1.375.041,6.791,6.791,0,1,1,3.774-12.705l-.134-.35a.569.569,0,1,1,1.063-.4l.566,1.48a.587.587,0,0,1,.037.176.568.568,0,0,1-.4.633l-1.515.464a.567.567,0,1,1-.329-1.086l.125-.038a5.669,5.669,0,0,0-1.13-.463,5.743,5.743,0,1,0-2.039,11.243A5.928,5.928,0,0,0,263.5,261.443Z",
    transform: "translate(-246.506 -239.542)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M412.165,351.447a.524.524,0,1,1,1.049,0v3.2l2.187.961a.524.524,0,1,1-.422.96l-2.474-1.087a.525.525,0,0,1-.34-.491Z",
    transform: "translate(-396.99 -338.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M503.608,563.763a.525.525,0,0,0,.475.937,6.672,6.672,0,0,0,.968-.6.525.525,0,1,0-.626-.843A5.627,5.627,0,0,1,503.608,563.763Z",
    transform: "translate(-484.79 -542.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M566.909,498.487a.525.525,0,1,0,.872.585,6.876,6.876,0,0,0,.553-.992.525.525,0,1,0-.956-.432,5.739,5.739,0,0,1-.469.839",
    transform: "translate(-545.95 -479.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M595.4,415.537a.525.525,0,1,0,1.045.1,6.931,6.931,0,0,0,.016-1.135.525.525,0,0,0-1.047.074,5.914,5.914,0,0,1-.013.962",
    transform: "translate(-573.473 -398.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M569.663,335.37a.525.525,0,0,0,.965-.415,6.9,6.9,0,0,0-.533-1,.525.525,0,0,0-.956.182.519.519,0,0,0,.074.386,5.669,5.669,0,0,1,.45.85",
    transform: "translate(-548.175 -321.425)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M64.171,97.91h5.305c.442,0,.437.73,0,.73H64.171a.367.367,0,0,1,0-.73",
    transform: "translate(-61.49 -94.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M64.171,273.583h5.936q.265-.379.567-.73h-6.5a.367.367,0,0,0,0,.731",
    transform: "translate(-61.49 -262.806)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M64.171,361.06h4.5q.085-.371.2-.73h-4.7a.367.367,0,0,0,0,.731",
    transform: "translate(-61.49 -347.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M64.171,448.536H68.51q-.044-.361-.06-.73H64.171a.367.367,0,0,0,0,.731",
    transform: "translate(-61.49 -431.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M.9,18.846V.9H9.825V4.542a.452.452,0,0,0,.452.451h3.736V7.08q.442-.108.9-.172V4.588a.884.884,0,0,0-.326-.565L10.622.165A.441.441,0,0,0,10.277,0H.805A.8.8,0,0,0,0,.8V18.936a.8.8,0,0,0,.805.8H7.7a9.193,9.193,0,0,1-.332-.9ZM10.725,1.574l2.691,2.52H10.725Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/AuditLog.ee280b95a0754dc6255b211568f27520.svg";
export { ForwardRef as ReactComponent };